<template>
    <ul class="flex items-center gap-4">
        <NuxtLink
            v-if="hasPrev"
            class="flex h-4 w-full cursor-not-allowed items-center justify-center rounded-3xl bg-gray-200 p-5 text-base text-black"
            :class="{ 'cursor-pointer bg-primary font-bold text-white': hasPrev }"
            :to="localePath(`/reviews/${page - 1 < 1 ? 1 : page - 1}`)">
            Prev
        </NuxtLink>
        <Component
            :is="button.ellipsis ? 'span' : defineNuxtLink({})" v-for="button in buttons"
            :key="button.page"
            :to="!button.ellipsis ? localePath(`/reviews/${button.page}`) : false"
            class="flex size-4 cursor-pointer items-center justify-center rounded-full bg-gray-200 p-5 text-base text-black"
            :class="{ 'cursor-none bg-primary font-bold text-white': button.active, 'cursor-none': button.ellipsis }">
            {{ button.ellipsis ? '...' : button.page }}
        </Component>
        <NuxtLink
            v-if="hasNext"
            class="flex h-4 w-full cursor-not-allowed items-center justify-center rounded-3xl bg-gray-200 p-5 text-base text-black"
            :class="{ 'cursor-pointer bg-primary font-bold text-white': hasNext }"
            :to="localePath(`/reviews/${page + 1 < numPages ? page + 1 : numPages}`)">
            Next
        </NuxtLink>
    </ul>
</template>

<script setup lang="ts">
    import type { Pagination } from '~/types/local-types'
    import { useResizeObserver } from '@vueuse/core'
    import usePaginator from 'vue-use-paginator'

    const props = defineProps<Pagination>()
    const localePath = useLocalePath()
    const route = useRoute()

    const {
        page,
        numPages,
        numButtons,
        buttons,
        hasPrev,
        hasNext
    } = usePaginator({
        page: computed(() => Number(route.params.page) ?? 1),
        pageSize: props.perPage,
        numItems: props.total,
        numButtons: 7
    })

    function setButtonAmount () {
        let buttonAmount = 7
        if (window.innerWidth < 640) {
            buttonAmount = 3
        } else if (window.innerWidth >= 640 && window.innerWidth < 768) {
            buttonAmount = 7
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
            buttonAmount = 5
        } else if (window.innerWidth >= 1024 && window.innerWidth < 1280) {
            buttonAmount = 5
        } else if (window.innerWidth >= 1280) {
            buttonAmount = 7
        }
        numButtons.value = buttonAmount
    }

    onMounted(() => {
        useResizeObserver(document.body, setButtonAmount)
    })
</script>
